<span class="td-wb-dropdown-item__data" [class.td-wb-dropdown-item__disabled]="disabled">
  <ng-content />
</span>
